import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios, { type AxiosError } from "axios"

interface RegisterCredentials {
	email: string
	username: string
	roles: string[]
	[key: string]: unknown
}

interface RegisterState {
	username: string
	firstname: string
	lastname: string
	birthday: string
	date: string
	phone: string
	palloid: string
	sporttiId: string
	email: string
	sex: string
	isSuccess: boolean
	isError: boolean
	isFetching: boolean
	[key: string]: unknown
}

const register = createAsyncThunk("user/register", async (registerCredentials: RegisterCredentials, thunkAPI) => {
	try {
		const email = registerCredentials.email
		const roles = registerCredentials.roles
		const username = registerCredentials.username
		const profile: Record<string, unknown> = { ...registerCredentials }
		delete profile.roles
		delete profile.email
		delete profile.username
		const body = { email, username, profile, roles }
		const response = await axios.post("http://127.0.0.1:3001/api/users", body)
		if (response.status === 200) {
			return response.data
		} else {
			return thunkAPI.rejectWithValue(response.data)
		}
	} catch (error) {
		return thunkAPI.rejectWithValue((error as AxiosError).response?.data)
	}
})

const initialState: RegisterState = {
	username: "",
	firstname: "",
	lastname: "",
	birthday: "",
	date: "",
	phone: "",
	palloid: "",
	sporttiId: "",
	email: "",
	sex: "",
	isSuccess: false,
	isError: false,
	isFetching: false,
}

export const registerSlice = createSlice({
	name: "register",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(register.fulfilled, (_state, { payload }) => {
				return {
					...payload,
					username: `${payload.username}`,
					firstname: `${payload.firstname}`,
					lastname: `${payload.lastname}`,
					roles: `${payload.roles}`,
					birthday: `${payload.date}`,
					date: `${payload.date}`,
					phone: `${payload.phone}`,
					palloid: `${payload.palloid}`,
					sporttiId: `${payload.sporttiId}`,
					email: `${payload.email}`,
					sex: `${payload.sex}`,
					isSuccess: true,
					isFetching: false,
					isError: false,
				}
			})
			.addCase(register.rejected, (state) => {
				state.isSuccess = false
				state.isFetching = false
				state.isError = true
			})
			.addCase(register.pending, (state) => {
				state.isSuccess = false
				state.isFetching = true
				state.isError = false
			})
	},
})
